<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>File Logs</h2>
                    </div>
                    <div class="col-lg-4 col-6 text-right bid">
                    <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                    <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <form v-if="moduleName == 'ims' || moduleName == 'ba'" @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchLog()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchLog" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>              
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="mt-2">Filters</h5>
              <span class="btn btn-outline-secondary" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row"  @submit.prevent=""  >
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Process</label>
                    <select v-model="processtype" class="form-control" style="height: 40px;" >
                      <option value="">SELECT</option>
                      <option value="UPLOAD">UPLOAD</option>
                      <option value="DOWNLOAD">DOWNLOAD</option>
                    </select> 
                  </div>
                  
                  
                 
                  <div class="col-md-4 col-lg-3">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="filelogs()" type="button" class="btn btn-success rounded mt-4">Filter</button>
                  </div>
                </form>
                
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >File Type</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >Process</th>     
                               <th 
                                    scope="col" 
                                    class="sort"
                                     >Message</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >Started at</th>  
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    >Completed at </th>     
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >Comments</th>
                                <!-- <th 
                                    scope="col" 
                                    class="sort"
                                    >Status</th> -->
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>                 
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="logs.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in logs" :key="data.id">
                                <td>{{data.fileType}}</td>
                                <td>{{data.fileLogType}}</td>
                                <td><span data-toggle="tooltip" data-placement="left"  v-bind:title='data.msg'>{{data.msg | truncate(20, '...')}}</span></td>
                                <td>{{data.startedAt ? moment(data.startedAt).format("MMMM DD YYYY, h:mm:ss a") : ""}}</td>
                                <td>{{data.completedAt ? moment(data.completedAt).format("MMMM DD YYYY, h:mm:ss a") : ""}}</td>
                                <td ><span data-toggle="tooltip" data-placement="left" v-bind:data-original-title='data.comments'>{{data.comments | truncate(20, '...')}}</span></td>
                                <!-- <td>{{data.status}}</td> -->
                                <td class="text-center">
                                    <div v-if="data.downloadKey">
                                    <button @click="downloadFile(data.downloadKey)" class="btn btn-warning rounded ml-2 mt-0" type="button">
                                        <i class="fas fa-download"></i>  DOWNLOAD
                                    </button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example" v-if="!(logs.length == 0 && currentPage === 0)">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                    <a class="page-link cursor-pointer"   @click="previous()">
                                        <i class="fa fa-angle-left"></i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>
                                <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                <li class="page-item" v-bind:class="{ disabled: this.logs.length < this.perPage }"  >
                                    <a class="page-link cursor-pointer" @click="next()">
                                        <i class="fa fa-angle-right"></i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <!-- Pagination-->
                        <!-- <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="filelogs(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div> -->
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 0,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "ASC",
        logs : [],
        moduleName : "",
        showFilters : false,
        processtype :"",
        fromDate : "",
        toDate : "",
     
    };
  },
  methods: {
    clearFilter(){
        this.processtype = "";
        this.fromDate = "";
        this.toDate = "";
        this.filelogs();
    },
    searchLog(){
        this.currentPage = 0;
        this.filelogs();  
    },
    downloadFile(downloadKey){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 0;
        this.filelogs();  
    },
    next(){
        if(this.logs.length === this.perPage){
            this.currentPage++;
            this.filelogs(); 
        }
        
    },
    previous(){
        if(this.currentPage > 0){
            this.currentPage--;
            this.filelogs(); 
        }
        
    },
    filelogs(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      var fileType = "DEMINIMIS_REPORT";
      
      var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD") : "";
      var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD") : "";
      this.$http
        .get(
          config.baseUrlAutoBidder + "/logs/file-upload"+
          "?offset="+this.currentPage+
          "&limit="+this.perPage+
          "&searchText="+this.searchValue+
          "&from="+fDate+
          "&to="+tDate+
          "&fileType="+fileType+
          "&messageType="+this.processtype,
          auth
        )
        .then((result) => {
            this.logs = result.data;
            this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
   
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const moduleName = urlParams.get('moduleName');
    this.moduleName = moduleName;
    this.filelogs()
  }
};
</script>